module.exports = __webpack_public_path__ + "static/media/collectible-mobile.fcdb01f9.jpg";